import * as React from 'react'
import {
  IStudentDetails,
  ITeacherDetails,
  IUserType,
} from '../../interfaces/user.interface'

import { GetUserDetailsRequest } from '../../services/api-requests/api-request'

type ISchoolUserDetails = ITeacherDetails | IStudentDetails

const useSchoolUserDetails = (
  schoolUserId: string,
  schoolId: string,
  userType: IUserType,
) => {
  const [schoolUserDetails, setSchoolUserDetails] = React.useState<
    ISchoolUserDetails
  >()

  const [
    schoolUserDetailsLoading,
    setSchoolUserDetailsLoading,
  ] = React.useState(false)

  React.useEffect(() => {
    getSchoolUserDetails(userType)
  }, [])

  async function getSchoolUserDetails(
    userType: IUserType,
  ): Promise<ISchoolUserDetails | undefined> {
    try {
      setSchoolUserDetailsLoading(true)
      const axiosResponse = await GetUserDetailsRequest(
        schoolUserId,
        userType,
        schoolId,
      )
      console.log('SchoolUser details response', axiosResponse)
      setSchoolUserDetailsLoading(false)
      if (axiosResponse && axiosResponse.data && axiosResponse.data.data) {
        const schoolUserDetails = axiosResponse.data.data
        setSchoolUserDetails(schoolUserDetails)
        return schoolUserDetails
      } else {
        throw new Error('Invalid response')
      }
    } catch (e) {
      setSchoolUserDetailsLoading(false)
      console.log('Error getting school details', e)
    }
  }

  return {
    details: schoolUserDetails,
    getSchoolUserDetails,
    schoolUserDetailsLoading,
  }
}

export default useSchoolUserDetails
